import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CheckOTPCode_Request } from '../../../models/CheckOTPCode_Request.model';
import { requiredLengthValidator } from '../../../required-length.validator';
import { OtpService } from '../../../services/otp.service';

@Component({
  selector: 'app-confirm-code',
  templateUrl: './confirm-code.component.html',
  styleUrls: ['./confirm-code.component.scss']
})
export class ConfirmCodeComponent implements OnInit {
  @Input() phone: string;
  @Output() submitCb: EventEmitter<CheckOTPCode_Request> = new EventEmitter<CheckOTPCode_Request>();
  @Output() backCb: EventEmitter<void> = new EventEmitter;

  otpSendCodeForm: FormGroup;
  isSubmitted: boolean = false;
  isErrorDisplayed: boolean = false;
  otpInstructionCode: string;

  constructor(private formBuilder: FormBuilder,
    private translate: TranslateService,
    public otpService: OtpService,
  ) { }

  ngOnInit() {
    this.otpSendCodeForm = this.formBuilder.group({
      code: ['', [Validators.required, requiredLengthValidator(6)]]
    });

    this.otpInstructionCode = this.translate.instant('otp.instructions-code');
    // const phoneArr = this.phone.split(/\-/gi);
    // this.phone = phoneArr[0] + ' - ' + phoneArr[1]
    this.phone = this.phone.replace(/\-/gi, '');
    this.otpInstructionCode = this.otpInstructionCode.replace(/{{selectedPhone}}/gi, this.phone);

    // setTimeout(() => {
    //   // console.log('this.currentStepSubject.subscribe...');
    //   this.focusToElement(`input[type="text"]`);
    // }, 10);
  }

  checkOTPCode() {
    this.isSubmitted = true;

    if (this.otpSendCodeForm.valid) {
      let otpCodeCheckReq: CheckOTPCode_Request = {
        code: this.otpSendCodeForm.value.code
      }

      this.submitCb.emit(otpCodeCheckReq);
    }
  }

  back() {
    this.backCb.emit();
    this.otpService.confirmCode = false;
  }

  // focusToElement(selector: string) {
  // 	const selectedElement = Array.from(document.querySelectorAll(selector));

  // 	if (selectedElement && selectedElement.length > 0) {
  // 		const nowActiveElement = document.activeElement;
  // 		(nowActiveElement as HTMLElement).blur();
  // 		setTimeout(() => (selectedElement[0] as HTMLElement).focus(), 0);
  // 	}
  // }
}



// WEBPACK FOOTER //
// ./src/app/login/otp/confirm-code/confirm-code.component.ts